import React, { FC } from "react";
import { useStyles } from "./RecentlyCard.styles";
import { FavouriteItemType } from "../../../modules/favourites/types";
import BulkExport from "../../../icons/homeNav/BulkExport";
import Map from "../../../icons/homeNav/Map";
import SlideIcon from "../../../icons/homeNav/Slide";

interface IRecentlyCardImage {
  type?: FavouriteItemType;
}

export const RecentlyCardImage: FC<IRecentlyCardImage> = ({ type = FavouriteItemType.Slide }) => {
  const classes = useStyles();

  const icons: Record<string, JSX.Element> = {
    [FavouriteItemType.Slide]: <SlideIcon />,
    [FavouriteItemType.Map]: <Map />,
    [FavouriteItemType.BulkExport]: <BulkExport />,
    [FavouriteItemType.SavedBulkExport]: <BulkExport />,
  };

  const currentIcon = icons[type];

  return <div className={classes.imageBox}>{currentIcon}</div>;
};
